export const convertUTCToLocalDate = (
    date,
    format = {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    }
) => {
    const utcDate = new Date(date)
    return new Date(
        Date.UTC(
            utcDate.getFullYear(),
            utcDate.getMonth(),
            utcDate.getDate(),
            utcDate.getHours(),
            utcDate.getMinutes(),
            utcDate.getSeconds()
        )
    ).toLocaleDateString('en-US', format)
}
